module.exports = __webpack_public_path__ + "img/Recognition.315bd632.png";